import { render, staticRenderFns } from "./all-games.vue?vue&type=template&id=7c5b335d&scoped=true&"
import script from "./all-games.vue?vue&type=script&lang=js&"
export * from "./all-games.vue?vue&type=script&lang=js&"
import style0 from "./all-games.vue?vue&type=style&index=0&id=7c5b335d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5b335d",
  null
  
)

export default component.exports